import React from 'react';
import { MilkTestEl } from './style';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { formatNumber } from '~/utils/helpers';

export type MilkTestType = {
  id: string;
  date: string;
  fat: string;
  protein: string;
  lactose: string;
  cellCount: number;
  germCount: number;
  freezingPoint: number | null;
  inhibitor: number | string;
  urea: number;
  fatFreeDryMatter: string;
  freeFattyAcid: string;
  inhibitorLabel: string;
};

interface MilkTestCardProps {
  test: MilkTestType;
  onEdit: () => void;
  isSelected: boolean;
}

export const MilkTestCard: React.FC<MilkTestCardProps> = ({
  test,
  onEdit,
  isSelected
}) => {
  const { t } = useTranslation()
  
  return (
    <MilkTestEl.StyledCard onClick={onEdit} selected={isSelected}>
      <MilkTestEl.CardContentWrapper>
        <MilkTestEl.Row>
          <span className='date'>
            {dayjs(test.date).format('DD MMM YYYY')}
          </span>
        </MilkTestEl.Row>

        <MilkTestEl.Grid>
          <MilkTestEl.Column>
            <div>
              <MilkTestEl.Label>{t('Fat %')}</MilkTestEl.Label>
              <MilkTestEl.Value color='#1E40AF'>{formatNumber(test.fat, 2)}</MilkTestEl.Value>
            </div>
            <div>
              <MilkTestEl.Label>{t('Protein %')}</MilkTestEl.Label>
              <MilkTestEl.Value color='#059669'>{formatNumber(test.protein, 2)}</MilkTestEl.Value>
            </div>
          </MilkTestEl.Column>

          <MilkTestEl.Column>
            <div>
              <MilkTestEl.Label>{t('Germ count (1000/ml)')}</MilkTestEl.Label>
              <MilkTestEl.Value color='#9333EA'>{formatNumber(test.germCount?.toString()?.replace(',', '.') || 0, 2)}</MilkTestEl.Value>
            </div>
            <div>
              <MilkTestEl.Label>{t('Cell count (1000/ml)')}</MilkTestEl.Label>
              <MilkTestEl.Value>
                {test.cellCount || 0}
              </MilkTestEl.Value>
            </div>
          </MilkTestEl.Column>
        </MilkTestEl.Grid>
      </MilkTestEl.CardContentWrapper>
    </MilkTestEl.StyledCard>
  );
};
